// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"ddd08562","543":"c2b3cd15","659":"7ca6f784","700":"d07dc9c2","765":"e4a022a0","950":"87e90c6e"}[chunkId] + ".chunk.css";
};